
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 14 14"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_34337","data-name":"Group 34337","transform":"translate(-86 -1)"}},[_c('g',{attrs:{"id":"Group_33074","data-name":"Group 33074","transform":"translate(86 1)"}},[_c('g',{attrs:{"id":"Group_33073","data-name":"Group 33073"}},[_c('circle',{attrs:{"id":"Ellipse_493","data-name":"Ellipse 493","cx":"7","cy":"7","r":"7","fill":"#3cc5aa"}}),_c('g',{attrs:{"id":"Group_33072","data-name":"Group 33072","transform":"translate(4 5)"}},[_c('path',{attrs:{"id":"Positive_Icon","data-name":"Positive Icon","d":"M2.554 4.552a.787.787 0 01-1.114 0L.23 3.343a.788.788 0 011.114-1.115L2 2.881 4.648.231a.788.788 0 111.113 1.114z","fill":"#fff"}})])])])])])
          )
        }
      }
    